import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(userId: string): Promise<Optional<ResponseData>> {
	const url: string = `${SERVICEBASEURL.USER}/User/${userId}`;
	return axios.get(url).toOptionalMapped((x) => x.data);
}

export interface Response {
	data: ResponseData;
}

export type ResponseData = {
	id: string;
	firstName: string;
	lastName: string;
	email: string;
	languageId: string;
	profilePicture: Image;
	roles: UserRole[];
	userSettings: UserSettingsApi;
	isActive: boolean;
	isExternallyAuthenticated: boolean;
};

export type Image = {
	id: string;
	url: string;
	availableSizes: number[];
};

export type UserRole = {
	id: string;
	name: string;
	permissions: [
		{
			id: string;
			systemName: string;
		},
	];
};

export type UserSettingsApi = {
	'Price.Currency'?: string;
	'Recipe.List.ValueScope': ValueScope;
	'Preferred.Nutrient.Ids'?: string;
};

export enum ValueScope {
	Total = 'Total',
	Person = 'Person',
	Parts = 'Parts',
	HundredGrams = 'HundredGrams',
}
